import { createFileRoute } from '@tanstack/react-router'
import { AssetPage } from '../../../../features/service/assets/asset-page'
import { assetPageSearchSchema } from '../../../../features/service/assets/search'

export const Route = createFileRoute('/_app/service/assets/$assetId')({
  // Sites & assets › the asset's site › its place.
  staticData: { crumb: 'serviceAsset' },
  validateSearch: assetPageSearchSchema,
  component: AssetPage,
})
